"use client";

import type { AddonDietAddonsRead } from "@repo/api/catalog/api/schemas/addon-diet-addons-read";
import { parseISO } from "date-fns";
import { useCallback } from "react";
import {
  buildAddonGtmItem,
  resolveAddonUnitPrice,
} from "@/features/addons/lib/addon-gtm-item";
import type { ConfigurationItemAddon } from "@/features/addons/types/configuration-item-addon.type";
import type { SubItemsPricing } from "@/features/addons/types/sub-Items-pricing.type";
import { sendEvent } from "../gtm/event";

type ReportRemovedAddonParams = {
  addon: AddonDietAddonsRead;
  cateringName?: string;
  categoryName?: string;
  entries: ConfigurationItemAddon[];
  // Addon quote of the position the addon is being dropped from — it still
  // carries the entries, so it prices them as the cart charged them (MPL-3873).
  pricing?: SubItemsPricing | null;
};

export const useAddonRemoveFromCartEvent = () =>
  useCallback(
    ({
      addon,
      cateringName,
      categoryName,
      entries,
      pricing,
    }: ReportRemovedAddonParams) => {
      const quantity = entries.reduce((sum, entry) => sum + entry.quantity, 0);
      if (quantity === 0) {
        return;
      }

      const unitPrice = resolveAddonUnitPrice({
        addon,
        entries,
        pricing,
      });

      sendEvent({
        event: "remove_from_cart",
        ecommerce: {
          currency: "PLN",
          value: unitPrice * quantity,
          items: [
            buildAddonGtmItem({
              addon,
              cateringName,
              categoryName,
              quantity,
              selectedDates: entries.map((entry) => parseISO(entry.date)),
              unitPrice,
            }),
          ],
        },
      });
    },
    [],
  );
